<template>
    <div
        class="Input Input--text"
        :class="{ 'Input--desktop': desktop }"
    >
        <label
            class="Input-labelText"
            :for="name"
            :class="{
                'Input--white': white,
                'Input--error': error,
        }">
            {{ label }}:
        </label>
        <input
            :type="type"
            :value="value"
            :name="name"
            @input="onChange"
            :placeholder="placeholder">
    </div>
</template>
<script>
export default {
    name: 'HempelText',
    props: {
        value: {
            type: [Number, String]
        },
        type: {
            type: String,
            default: 'number'
        },
        label: {
            type: String,
            required: true
        },
        placeholder: {
            type: String,
            required: true
        },
        name: {
            type: String,
            required: true
        },
        error: {
            type: Boolean,
            default: false
        },
        white: {
            type: Boolean,
            default: false
        },
        desktop: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        onChange(e) {
            // NOTE: should be elsewhere
            const groupOne = document.querySelector('.group-individual')
            const groupTwo = document.querySelector('.group-m2')
            const individualValues = groupOne ? groupOne.querySelectorAll('input') : null
            const individualValuesList = []
            if (
                e.srcElement.name === 'waterline' ||
                e.srcElement.name === 'beam' ||
                e.srcElement.name === 'draft'
            ) {
                individualValues.forEach(item => {
                    individualValuesList.push(item.value)
                    if (individualValuesList.every(element => element === '')) {
                        groupTwo.classList.remove('disabled-input-block')
                    } else {
                        groupTwo.classList.add('disabled-input-block')
                    }
                })
            }
            if (e.srcElement.name === 'm2' && e.srcElement.value) {
                groupOne.classList.add('disabled-input-block')
            } else {
                if (groupOne) {
                  groupOne.classList.remove('disabled-input-block')
                }
            }
            // NOTE: end of "should be elsewhere"
            this.$emit('input', {
                value: e.target.value
            })
        }
    }
}
</script>
